import {Button, message, Modal, Popconfirm, Select, Spin, Tooltip} from 'antd'
import React from 'react'
import { CustomRow, CustomCol } from '../../components/Custom';
import DetailTitle from '../../components/DetailTitle';
import FileUpload_JR from '../../components/FileUpload_JR';

import { Row,Col,Form, Input, InputNumber } from "antd";
import {
    attachTitleTypeMap,
    deviceAttachTitleTypeMap,
    houseTypeLabelMap,
    houseWindowTypeMap
} from '../../axios/dictionaries';
import {config, post, postFrom} from '../../axios';
import {
    API_category_device_deleteDeviceLayout,
    API_device_findList,
    API_houseType_create,
    API_houseType_edit,
    API_houseType_getById,
    API_salesroom_findList
} from '../../axios/config';
import {fetchDeviceListAll} from "../../services/device";

class HouseTypeDetail extends React.Component{
  state = {
    id: null,
    visible: false,
    dataInfo: {},
    salesroomList: [],
      deviceList:[],
    dataLoading: false,
    submitLoading: false,
    data: {
        houseLayout: []
    }
  }
  open(id = null) {
    if (id) {
      this.postHouseTypeGet(id)
    }
    this.postDeviceList();
    this.postSalesroomList()
    this.setState({ visible: true, id })
    return new Promise((resolve,reject) => {
      this.monitor = { resolve, reject }
    })
  }
  close() {
    this.setState({ visible: false ,data: {}})
    this.props.form.resetFields()
    this.fileUploadRef_attachIds.set([])
  }
  renderFooter() {
    return (
      <div className="app-modal-footer">
        <Button type="primary" onClick={this.handleSubmit.bind(this)} loading={this.state.submitLoading}>保存</Button>
        <Button onClick={this.close.bind(this)}>取消</Button>
      </div>
    )
  }
  postSalesroomList() {
    post({ url: API_salesroom_findList }).then(res =>{
      this.setState({ salesroomList: res })
    })
  }
    postDeviceList() {
        post({ url: API_device_findList }).then(res =>{
            this.setState({ deviceList: res })
        })
    }
  postHouseTypeSubmit(data) {
    const url = data.id ? API_houseType_edit : API_houseType_create
    this.setState({ submitLoading: true })

    return post({ url, data }).then(res => {
       // this.setState({ submitLoading: false })
    }).finally(err => {
      this.setState({ submitLoading: false })
    })
  }
  postHouseTypeGet(id) {
    this.setState({ dataLoading: true })
    post({ url: API_houseType_getById + '?roomTypeId=' + id  }).then(res => {
      const data = {
        balcony: res.balcony,
        ccbProjectId: res.ccbProjectId,
        bathroom: res.bathroom,
        bedroom: res.bedroom,
        ccbProjectName: res.ccbProjectName,
        kitchen: res.kitchen,
        label: res.label ? res.label.split(','): [],
        livingroom: res.livingroom,
        maxArea: res.maxArea,
        maxRent: res.maxRent,
        minArea: res.minArea,
        minRent: res.minRent,
        roomTypeName: res.roomTypeName,
        windowType:res.windowType
      }

        res.houseLayout = res.houseLayout.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
            item.key = index;
            item.f= item.categoryName;
            item.t= item.deviceId;
            return item
        });

      this.props.form.setFieldsValue(data)
      this.fileUploadRef_attachIds.set(res.roomTypeImages)
      this.setState({ data: res,dataLoading: false })
    }).catch(err => {
      this.setState({ dataLoading: false });
    })
  }
  handleSubmit() {
    this.props.form.validateFields((err, values) => {
      if (err) return
      values.id = this.state.id || undefined
      values.label = values.label.join(',')
      values.attachIds = this.fileUploadRef_attachIds.get().map(e => e.id)
      if (values.attachIds.length < 5 || values.attachIds.length > 10) return message.warning('介绍图片最少需5张，最多只能十张！')

        let { data: { houseLayout } } = this.state;

        let valueKeys = Object.keys(values);
        let fKeys = valueKeys.filter((item, index) => { //获取出户型字段
            if (/^f[\d]+$/.test(item)) return item;
        });
        values.device=true;
        values.houseLayout = fKeys.map((item, index) => { //处理户型字段
            let id = houseLayout[index].id;
            let roomTypeId = houseLayout[index].roomTypeId;
            let num = item.slice(1);
            item = {
                id: id || 0,
                roomTypeId: roomTypeId || 0,
                categoryName: values[`f${num}`],
                deviceId: values[`t${num}`]
            };
            delete values[`f${num}`];
            delete values[`t${num}`];
            return item
        });

      this.postHouseTypeSubmit(values).then(() => {
        this.close()
        this.monitor.resolve()
        message.success('保存成功')
      }).catch((e) => {
        message.error(e.message)
      })
    })
  }
  render(){
    const modalConfig = {
      title: this.state.id ? '编辑户型' : '新增户型',
      visible: this.state.visible,
      footer: this.renderFooter(),
      width: 700,
      onCancel: () => this.close()
    }
  let {
      data,
  } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form
    const labelWidth = 100
    const labelValue = getFieldValue('label')
    return (
      <Modal {...modalConfig}>
        <Spin spinning={this.state.dataLoading}>
          <div className="custom" style={{padding: 20}}>
            <Form  labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
              <Row>
                <Col span={24}>
                  <DetailTitle title="基本信息" boxStyle={{ marginTop: '0' }} />
                  <CustomRow >

                    <CustomCol labelStyle={{ width: labelWidth }} label="户型名称">
                        {getFieldDecorator('roomTypeName', {
                            rules: [{ required: true, message: '请输入户型名称', }],
                        })(
                            <Input
                                placeholder={'请输入'}
                                autoComplete={'off'}
                            />
                        )}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} label="所属门店">
                        {getFieldDecorator('ccbProjectId', {
                            rules: [{
                                required: true, message: '请选择所属门店',
                            }],
                        })(
                          <Select placeholder="请选择">
                            {this.state.salesroomList.map(e => (
                              <Select.Option key={e.id} value={e.id}>{ e.projectName }</Select.Option>
                            ))}
                          </Select>
                        )}
                    </CustomCol>
                  </CustomRow>
                    <CustomRow divider>
                        <CustomCol labelStyle={{ width: labelWidth }} label="最小计租面积">
                            {getFieldDecorator('minArea', {
                                rules: [{
                                    required: true, message: '请输入最小计租面积',
                                }],
                            })(
                                <InputNumber
                                    min={5}
                                    max={1000}
                                    placeholder={`范围: 5 ~ 1000`}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol labelStyle={{ width: labelWidth }} label="最大计租面积">
                            {getFieldDecorator('maxArea', {
                                rules: [{
                                    required: true, message: '请输入最大计租面积',
                                }],
                            })(
                                <InputNumber
                                    min={5}
                                    max={1000}
                                    placeholder={`范围: 5 ~ 1000`}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>
                  <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{width: 500}} label="推荐标签">
                      {getFieldDecorator('label', {
                          rules: [{
                              required: true, message: '请选择推荐标签',
                          }],
                      })(
                        <Select
                            mode="multiple"
                            tokenSeparators={[',']}
                            placeholder="请选择(最多选择3个)"
                        >
                          {
                            labelValue && labelValue.length >= 3 ?
                            [] :
                            houseTypeLabelMap.map((item, index) => <Select.Option key={ item.value } value={ item.value }>{ item.title }</Select.Option>)
                          }
                        </Select>
                      )}
                    </CustomCol>

                  </CustomRow>

                  <DetailTitle title="户型结构"  />
                    {
                        data.houseLayout instanceof Array
                            ? data.houseLayout.map((item, index) => {
                                return <CustomRow key={item.key}>
                                    <CustomCol label="品类">
                                        {getFieldDecorator(`f${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.f
                                        })(
                                            <Select placeholder="请选择">
                                                {deviceAttachTitleTypeMap.map(e => (
                                                    <Select.Option key={e.title} value={e.title}>{ e.value }</Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </CustomCol>
                                    <CustomCol label="设备">
                                        {getFieldDecorator(`t${item.key}`, {
                                            rules: [{
                                                required: true, message: '请选择',
                                            }],
                                            initialValue: item.t
                                        })(
                                            <Select placeholder="请选择">
                                                {this.state.deviceList.map(e => (
                                                    <Select.Option key={e.id} value={e.id}>{ e.deviceCategory }</Select.Option>
                                                ))}
                                            </Select>
                                        )}
                                    </CustomCol>
                                    <div style={{display: 'flex', justifyContent: 'center', padding: '5px 0'}}>
                                        <Popconfirm
                                            placement="topRight"
                                            title={'此删除操作不可恢复，确定删除吗？'}
                                            onConfirm={() => {
                                                this.handleMinus(index)
                                            }}
                                            okText="删除"
                                            cancelText="取消"
                                        >
                                            <Button style={{
                                                marginLeft: '12px',
                                                width: '30px',
                                                height: '30px'
                                            }} shape="circle" icon="minus" />
                                        </Popconfirm>
                                    </div>
                                </CustomRow>
                            })
                            : null

                    }
                    {
                        <div style={{marginTop: '20px', textAlign: 'center'}}>
                            <Tooltip placement="bottomLeft" title={"添加一行户型输入框"}>
                                <Button onClick={() => {
                                    this.handlePlus()
                                }} style={{
                                    width: '40px',
                                    height: '40px',
                                    textAlign: 'center',
                                    lineHeight: '36px',
                                    fontSize: '20px'
                                }} shape="circle" icon="plus"/>
                            </Tooltip>
                        </div>
                    }
                  <DetailTitle title="介绍图片" />
                  <div style={{marginBottom: 10}}>最少5张, 最多10张</div>
                  <FileUpload_JR hasTitle ref={(ref) => this.fileUploadRef_attachIds = ref}  count={10}  attachType={16} />
                </Col>
              </Row>
            </Form>
          </div>
        </Spin>
      </Modal>
    )

  }
  handleMinus = (index) => { //房源户型减1
        let { data } = this.state;
        let item = data.houseLayout[index];
        if (item) {
            if (item.id) {
                this.setState({ loading: true });
                postFrom({ url: config.API_category_device_deleteDeviceLayout, data: { houseLayoutId: item.id } }).then(res => {
                    data.houseLayout.splice(index, 1);
                    this.setState({ data, loading: false });
                }).catch(err => {
                    message.error(err.message || '删除失败');
                    this.setState({ loading: false })
                });
            } else {
                data.houseLayout.splice(index, 1);
                this.setState({ data });
            }
        }
    }

    handlePlus = () => { //房源户型加1
        let { data } = this.state;
        if (data.houseLayout instanceof Array) {
            if (data.houseLayout.length) {
                data.houseLayout.push({ key: data.houseLayout[data.houseLayout.length - 1].key + 1, f: '', t: '', });
            } else {
                data.houseLayout.push({ key: 0, f: '', t: '' });
            }
        } else {
            data.houseLayout = [{ key: 0, f: '', t: '' }];
        }
        this.setState({ data });
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({ data: {}, loading: false, title: "新增小区/楼栋" });
    }
}



export default Form.create({ wrappedComponentRef: true })(HouseTypeDetail)


// WEBPACK FOOTER //
// ./src/page/DeviceHouseType/detail.jsx